<ng-template
	#affixTemplate
	let-row>
	<app-card-table-actions
		[row]="row"
		[actions]="row.lat == 0 && row.lng == 0 ? unknownLocationRowActions : rowActions"
		(actionEvent)="onAction($event)"
		[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
</ng-template>

@if (isLoaded) {
<app-card-table

	[tableHeaders]="headers"
	[data]="data"
	[options]="options"
	[affixTemplate]="affixTemplate"
	[enableInfiteScroll]="true"
	[enableRefresher]="true"
	[enableTablePagination]="false"
	(dataScrolledEvent)="loadMoreData($event)"
	[breakpoint]="ScreenSize.TABLET">
</app-card-table>
}
